import axios from 'axios';
import {buildQuery} from '../utils/QueryUtils';

export const findMedia = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/media${query}`, {
    headers,
  });
};

export const findMediaById = (headers, id) => {
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/media/${id}`, {
    headers,
  });
};

export const createMedia = (headers, data) => {
  return axios.post(`${process.env.REACT_APP_INFO_API_URL}/media`, data, {
    headers,
  });
};

export const uploadMedia = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_INFO_API_URL}/media/upload`,
    data,
    {
      headers,
    },
  );
};

export const updateMedia = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/media/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteMedia = (headers, id) => {
  return axios.delete(`${process.env.REACT_APP_INFO_API_URL}/media/${id}`, {
    headers,
  });
};
